import { MyAccountUiStore } from "./MyAccountUiStore";
import AccountOnBoardingStore from "./AccountOnBoardingStore"
import AccountUserStore from "./AccountUserStore";
import { ReplaceCardStore } from "./ReplaceCardStore";

export const MyAccountStores = {
    ui: new MyAccountUiStore(),
    accountUserStore: new AccountUserStore(),
    accountOnBoardingStore: new AccountOnBoardingStore(),
    replaceCardStore: new ReplaceCardStore()
};



// WEBPACK FOOTER //
// ./src/scenes/MyAccount/state/mobx/index.ts